import { z } from 'zod';

// ============================================================================
// Special Events (P2-PRC-002)
// ============================================================================

export const CreateSpecialEventRequestSchema = z.object({
  name: z.string().min(1, 'name is required'),
  dateFrom: z.string().date(),
  dateTo: z.string().date(),
  description: z.string().optional(),
  multiplier: z
    .number()
    .min(0.7, { message: 'Multiplier must be at least 0.70 (dynamic pricing minimum)' })
    .max(2.0, { message: 'Multiplier must be at most 2.00 (dynamic pricing maximum)' }),
  isPublic: z.boolean().optional(),
  createdBy: z.string().optional(),
});

export type CreateSpecialEventRequest = z.infer<typeof CreateSpecialEventRequestSchema>;

export const UpdateSpecialEventRequestSchema = z.object({
  name: z.string().min(1).optional(),
  dateFrom: z.string().date().optional(),
  dateTo: z.string().date().optional(),
  description: z.string().optional(),
  multiplier: z
    .number()
    .min(0.7, { message: 'Multiplier must be at least 0.70 (dynamic pricing minimum)' })
    .max(2.0, { message: 'Multiplier must be at most 2.00 (dynamic pricing maximum)' })
    .optional(),
  isPublic: z.boolean().optional(),
});

export type UpdateSpecialEventRequest = z.infer<typeof UpdateSpecialEventRequestSchema>;

export const ListEventsQuerySchema = z.object({
  includePrivate: z
    .string()
    .transform((v) => v === 'true')
    .optional(),
});

export type ListEventsQuery = z.infer<typeof ListEventsQuerySchema>;

// ============================================================================
// Response schema — Prisma SpecialEvent serialised as JSON
// ============================================================================

export const SpecialEventRecordSchema = z.object({
  id: z.string(),
  name: z.string(),
  dateFrom: z.string().date(),
  dateTo: z.string().date(),
  description: z.string().nullable(),
  multiplier: z.number(),
  isPublic: z.boolean(),
  createdBy: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type SpecialEventRecord = z.infer<typeof SpecialEventRecordSchema>;
